// src/hooks/useRequests.js
import { useMemo, useState } from "react";
import { supabase } from "../lib/supabaseClient";
import { useToast } from "../context/ToastContext";

export function useRequests(me) {
  const { setToast } = useToast();
  // requests data
  const [requests, setRequests] = useState([]);
  const [loadingRequests, setLoadingRequests] = useState(false);

  // ---------------- DATA LOADERS ----------------
  const loadRequests = async () => {
    if (!me?.org_id) return;
    setLoadingRequests(true);
    try {
      const { data, error } = await supabase
        .from("foia_requests")
        .select("*")
        .eq("org_id", me?.org_id)
        .order("created_at", { ascending: false })
        .limit(5000);
      if (error) throw error;
      setRequests(data || []);
    } catch (e) {
      setToast({ type: "error", msg: `Load requests failed: ${e.message}` });
    } finally {
      setLoadingRequests(false);
    }
  };

  // ---------------- ANALYTICS ----------------
  const analytics = useMemo(() => {
    const total = requests.length;
    const requested = requests.filter(r => r.status === "requested").length;
    const open = requests.filter(r => r.status === "not_requested").length;
    const received = requests.filter(r => r.status === "received").length;
    const denied = requests.filter(r => r.status === "denied").length;
    
    const today = new Date().toISOString().split("T")[0];
    const requestedToday = requests.filter(r => {
      if (!r.date_requested) return false;
      const reqDate = new Date(r.date_requested).toISOString().split("T")[0];
      return reqDate === today;
    }).length;

    return { total, requested, open, received, denied, requestedToday };
  }, [requests]);

  return { requests, setRequests, loadingRequests, loadRequests, analytics };
}
